import { Directive } from '@angular/core';

@Directive({
    selector: '[pCardFooter]',
})
export class CardFooterDirective {}
